module.exports = __webpack_public_path__ + "static/media/fourteenth_the_inn1.2869ffae.jpg";